export default __webpack_public_path__ + "static/media/websafe-365-main-app-ui.8e2d6e33.png";